export default {
    promiles_request_title: "Promiles Request",
    promiles_request_account: "Account",
    promiles_request_date_range: "Date Range",
    promiles_request_send_request: "Send Request",
    promiles_request_success_message: "Promiles request successfully sent",
    promiles_request_error_message: "Promiles request not sent due to error",
}